export enum VariableType {
    Dependent = 'dependent',
    Independent = 'independent'
}
